import { useEffect, useState } from 'react';
import { Observable } from '../../Data/Observable/Observable';
import { checkColorType } from '../../Helpers/Hex/Color';
const default_color_scheme = {
    scheme: 'default',
    status_bar_color: 'dark',
    colors: {
        empty_background_color: '#f1f4f5',
        default_text: '#394e66',
        text: '#394e66',
        background: '#fff',
        primary: '#db007d',
        secondary: '#1155cc',
    }
};
const color_scheme = new Observable(default_color_scheme);
export function setColorScheme(scheme) {
    var _a, _b;
    const value = Object.assign(Object.assign({}, scheme), { scheme: scheme.scheme || 'default', status_bar_color: checkColorType(((_a = scheme.colors) === null || _a === void 0 ? void 0 : _a.background) || default_color_scheme.colors.background), colors: Object.assign(Object.assign({}, default_color_scheme.colors), Object.entries(scheme.colors || {}).reduce((acc, [key, value]) => {
            if (!value) {
                acc[key] = default_color_scheme.colors[key];
            }
            else {
                acc[key] = value;
            }
            return acc;
        }, {})) });
    if (value.scheme === 'light') {
        value.colors.text = '#000';
    }
    else if (value.scheme === 'dark') {
        value.colors.text = '#fff';
        if (!((_b = scheme.colors) === null || _b === void 0 ? void 0 : _b.empty_background_color)) {
            value.colors.empty_background_color = '#63788f';
        }
    }
    if (JSON.stringify(value) === JSON.stringify(color_scheme.value)) {
        return color_scheme;
    }
    return color_scheme.next(value);
}
export function getColorScheme() {
    return color_scheme;
}
export function useColorScheme() {
    const [color_scheme_state, set_color_scheme_state] = useState(color_scheme.value);
    useEffect(() => {
        const sub = color_scheme.subscribe(set_color_scheme_state);
        return () => sub.unsubscribe();
    }, []);
    return color_scheme_state;
}
